import { BENEFITS_ENUM } from '@/enums/goodEnum';
import UserService from '@/service/user';
import { defineStore } from 'pinia';

/**
 * 权益项
 */
export type BenefitsItem = {
    title: string;
    sign: BENEFITS_ENUM;
    endTime: string;
};

// 权益
export type Benefits = {
    /**
     * 权益列表
     */
    benefitsList: Array<BenefitsItem>;
    /**
     * 最新一次请求权益列表是否成功
     */
    loadBenefitsSuccess: Boolean;
};

export const useBenefitsStore = defineStore({
    id: 'app-benefits',
    persist: true,
    state: (): Benefits => ({
        benefitsList: [],
        loadBenefitsSuccess: false,
    }),
    actions: {
        async updateBenefitsList() {
            const list = await UserService.getPrivilegeList({
                error: () => (this.loadBenefitsSuccess = false),
            });
            this.benefitsList = list;
            this.loadBenefitsSuccess = true;
        },
    },
});
